var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.353,
    height: 57.414,
    viewBox: "0 0 57.353 57.414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1602",
    "data-name": "Group 1602",
    transform: "translate(295.72 644.155)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1383",
    "data-name": "Path 1383",
    d: "M-268.727-586.741c-1.088-.147-2.185-.243-3.261-.449a28.376,28.376,0,0,1-20.363-14.816A26.839,26.839,0,0,1-295.7-616.1a28.158,28.158,0,0,1,10.608-21.542,27.653,27.653,0,0,1,15.17-6.3c1.792-.183,3.606-.146,5.463-.211-.2,1.983-.388,3.851-.584,5.8-8.122-.416-14.953,2.27-20.13,8.606a21.83,21.83,0,0,0-5.013,16.159,22.971,22.971,0,0,0,22.868,21.1,22.31,22.31,0,0,0,17.028-7.671c4.556-5.04,6.31-11.054,5.845-17.833l5.777-.586.3,1.362v3.473c-.046.4-.093.807-.138,1.21a28.277,28.277,0,0,1-6.171,14.979,28.274,28.274,0,0,1-17.488,10.369c-1.06.19-2.134.3-3.2.44Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1384",
    "data-name": "Path 1384",
    d: "M-9.643-639.88-19.864-629.6h7.3v5.712h-17.1V-641H-24v7.4l10.322-10.331c1.226,1.227,2.4,2.4,3.569,3.568a5.628,5.628,0,0,0,.465.377Z",
    transform: "translate(-228.724 -0.187)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1385",
    "data-name": "Path 1385",
    d: "M-106.175-547.8h8.549v5.748h-.615c-4.348,0-8.7-.009-13.043.012-.515,0-.654-.138-.652-.653q.026-9.4,0-18.808c0-.516.138-.664.653-.652,1.492.034,2.986.037,4.478,0,.537-.014.642.17.64.665-.018,4.31-.01,8.621-.01,12.931Z",
    transform: "translate(-157.997 -70.494)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/In.00fb1cf4041d76433a600a9ead54300d.svg";
export { ForwardRef as ReactComponent };